module.exports = __webpack_public_path__ + "static/media/give.534fb659.svg";